import { ExerciseStatus } from '@datacamp/exercise-contract';
import { PureComponent } from 'react';
import { connect } from 'react-redux';
import selectInteractionBlocked from '../selectors/selectInteractionBlocked';
import selectLastSubmission from '../selectors/selectLastSubmission';
import selectXpLost from '../selectors/selectXpLost';

// eslint-disable-next-line @typescript-eslint/no-empty-interface

class LifecycleComponent extends PureComponent {
  componentDidMount() {
    const {
      exercise
    } = this.props;
    this.checkExerciseStatus({
      exercise
    });
    if (exercise === undefined) {
      return;
    }
    this.checkExerciseReady({
      exercise
    });
  }
  componentDidUpdate(prevProps) {
    const {
      exercise,
      lastSubmission,
      xpLost
    } = this.props;
    this.checkExerciseStatus({
      exercise
    });
    if (exercise === undefined) {
      return;
    }
    this.checkExerciseReady({
      exercise,
      prevExercise: prevProps.exercise
    });
    this.checkXp({
      exercise,
      prevExercise: prevProps.exercise,
      prevXpLost: prevProps.xpLost,
      xpLost
    });
    this.checkLastSubmission({
      exercise,
      lastSubmission,
      prevLastSubmission: prevProps.lastSubmission
    });
  }
  render() {
    return null;
  }
  checkExerciseReady(_ref) {
    let {
      exercise,
      prevExercise
    } = _ref;
    const {
      onExerciseReady
    } = this.props;
    if (prevExercise === undefined || prevExercise.id !== exercise.id) {
      onExerciseReady({
        id: exercise.id
      });
    }
  }
  checkExerciseStatus(_ref2) {
    let {
      exercise
    } = _ref2;
    const {
      exerciseId,
      interactionBlocked,
      onExerciseStatusUpdate,
      workbook
    } = this.props;
    if (exercise === undefined || workbook === undefined || interactionBlocked) {
      onExerciseStatusUpdate({
        id: exerciseId,
        status: ExerciseStatus.BUSY
      });
    } else {
      onExerciseStatusUpdate({
        id: exerciseId,
        status: ExerciseStatus.READY
      });
    }
  }
  checkXp(_ref3) {
    let {
      exercise,
      prevExercise,
      prevXpLost,
      xpLost
    } = _ref3;
    const {
      onXpUpdated
    } = this.props;
    if (prevExercise === undefined) {
      return;
    }
    if (exercise.xp !== prevExercise.xp || xpLost !== prevXpLost) {
      const newXp = exercise.xp - xpLost;
      onXpUpdated({
        id: exercise.id,
        xp: newXp
      });
    }
  }
  checkLastSubmission(_ref4) {
    let {
      exercise,
      lastSubmission,
      prevLastSubmission
    } = _ref4;
    const {
      onExerciseSubmitted
    } = this.props;
    if (lastSubmission !== undefined && lastSubmission !== prevLastSubmission) {
      onExerciseSubmitted({
        correct: lastSubmission.success,
        id: exercise.id,
        message: lastSubmission.message,
        submission: '[Google Sheets]' // submission is not a string for spreadsheets
      });
    }
  }
}
export default connect((state, _ref5) => {
  let {
    exerciseId
  } = _ref5;
  return {
    interactionBlocked: selectInteractionBlocked(state, exerciseId),
    lastSubmission: selectLastSubmission(state, exerciseId),
    xpLost: selectXpLost(state, exerciseId)
  };
})(LifecycleComponent);